import { BID_TYPE } from "./bid/bidConstants";

export const HOME_PATH = "/home";

export const ACCESS_REQUIREMENTS = Object.freeze({
  ADMIN: "admin",
  SUPERUSER: "superuser",
});

export const STATUS_OFFERED = "Offered";
export const STATUS_SUBMITTED = "Submitted";
export const STATUS_DECLINED = "Declined";
export const STATUS_APPROVED = "Approved";
export const STATUS_REFUSED = "Refused";
export const STATUS_CANCEL_OFFERED = "Cancel Offered";
export const STATUS_CANCEL_SUBMITTED = "Cancel Submitted";
export const STATUS_CANCEL_DECLINED = "Cancel Declined";
export const STATUS_CANCEL_REFUSED = "Cancel Refused";
export const STATUS_CANCELED_EE = "Canceled-EE";
export const STATUS_CANCELED_ADM = "Canceled-ADM";
export const STATUS_RETRACTED = "Retracted";
export const STATUS_EXPIRED_EE = "Expired-EE";
export const STATUS_EXPIRED_ADM = "Expired-ADM";
export const STATUS_CANCEL_EXPIRED_EE = "Cancel Expired-EE";
export const STATUS_CANCEL_EXPIRED_ADM = "Cancel Expired-ADM";

export const ACTION_OFFER = "Offer";
export const ACTION_ACCEPT = "Accept";
export const ACTION_DECLINE = "Decline";
export const ACTION_APPROVE = "Approve";
export const ACTION_REFUSE = "Refuse";
export const ACTION_CANCEL_OFFER = "Cancel Offer";
export const ACTION_CANCEL_SUBMIT = "Cancel Submit";
export const ACTION_CANCEL = "Cancel";
export const ACTION_CANCEL_ACCEPT = "Cancel Accept";
export const ACTION_CANCEL_DECLINE = "Cancel Decline";
export const ACTION_CANCEL_APPROVE = "Cancel Approve";
export const ACTION_CANCEL_REFUSE = "Cancel Refuse";
export const ACTION_RETRACT = "Retract";
export const ACTION_REINSTATE = "Reinstate";

export const WORKGROUP_CSA = "CSA";
export const WORKGROUP_CARGO_AGENT = "Cargo Agent";
export const WORKGROUP_OPS_AGENT = "Ops Agent";
export const WORKGROUP_PROVO_AGENT = "Provo Agent";
export const WORKGROUP_RAMP_AGENT = "Ramp Agent";
export const WORKGROUP_ATW_SUP = "ATW Sup";
export const WORKGROUP_BTW_SUP = "BTW Sup";
export const WORKGROUP_CARGO_SUP = "Cargo Sup";
export const WORKGROUP_DUTY_SUP = "Duty Sup";
export const WORKGROUP_PROVO_SUP = "Provo Sup";
export const WORKGROUP_SSO_TEAM_LEAD = "SSO Team Lead";
export const WORKGROUP_SSO_SPECIALIST = "SSO Specialist";
export const WORKGROUP_STA_ADMIN = "Sta Admin";
export const WORKGROUP_MANAGER = "Manager";

export const NC_PTO_FTO_BID_WORKGROUPS = Object.freeze({
  STA_ADMIN: WORKGROUP_STA_ADMIN,
  SSO_SPECIALIST: WORKGROUP_SSO_SPECIALIST,
});

export const NC_PTO_GOC_HOL_BID_WORKGROUPS = Object.freeze({
  ATW_SUP: WORKGROUP_ATW_SUP,
  BTW_SUP: WORKGROUP_BTW_SUP,
  CARGO_SUP: WORKGROUP_CARGO_SUP,
  DUTY_SUP: WORKGROUP_DUTY_SUP,
  PROVO_SUP: WORKGROUP_PROVO_SUP,
  SSO_TEAM_LEAD: WORKGROUP_SSO_TEAM_LEAD,
});

export const EMPLOYEE_1 = "Employee #1";
export const EMPLOYEE_2 = "Employee #2";

export const TRADE_DEFAULT_WORKGROUP_FILTERS = [
  WORKGROUP_CSA,
  WORKGROUP_CARGO_AGENT,
  WORKGROUP_OPS_AGENT,
  WORKGROUP_PROVO_AGENT,
  WORKGROUP_RAMP_AGENT,
  WORKGROUP_ATW_SUP,
  WORKGROUP_BTW_SUP,
  WORKGROUP_CARGO_SUP,
  WORKGROUP_DUTY_SUP,
  WORKGROUP_PROVO_SUP,
  WORKGROUP_SSO_TEAM_LEAD,
  WORKGROUP_SSO_SPECIALIST,
  WORKGROUP_STA_ADMIN,
];

export const ALL_STATUSES = [
  STATUS_OFFERED,
  STATUS_SUBMITTED,
  STATUS_APPROVED,
  STATUS_DECLINED,
  STATUS_REFUSED,
  STATUS_CANCEL_OFFERED,
  STATUS_CANCEL_SUBMITTED,
  STATUS_CANCELED_EE,
  STATUS_CANCELED_ADM,
  STATUS_RETRACTED,
  STATUS_EXPIRED_EE,
  STATUS_EXPIRED_ADM,
];

export const ALL_ADMIN_STATUSES = [
  STATUS_OFFERED,
  STATUS_SUBMITTED,
  STATUS_APPROVED,
  STATUS_DECLINED,
  STATUS_REFUSED,
  STATUS_CANCEL_SUBMITTED,
  STATUS_CANCELED_EE,
  STATUS_CANCELED_ADM,
  STATUS_RETRACTED,
  STATUS_EXPIRED_EE,
  STATUS_EXPIRED_ADM,
];

export const ALL_TOR_WOP_STATUSES = [
  STATUS_SUBMITTED,
  STATUS_APPROVED,
  STATUS_REFUSED,
  STATUS_RETRACTED,
  STATUS_CANCELED_ADM,
];

export const CONFIRM_TITLE = "Confirm";
export const INFO_TITLE = "Information";

export const WEEKDAYS_SHORT = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

export const SHIFT_TRADE = "Shift Trade";
export const TIME_TRADE = "Time Trade";
export const GIVEAWAY = "Giveaway";
export const ALL_TRADE_TYPES = [SHIFT_TRADE, TIME_TRADE, GIVEAWAY];
export const EMPLOYEE_TRADE_TYPES = [EMPLOYEE_1, EMPLOYEE_2];

export const ACQUIRED_SHIFT = "Acquired Shift";
export const LAST_UPDATED = "Last Updated";
export const STATUS = "Status";
export const TRADE_TYPE = "Trade Type";
export const TIME_OFF_TYPE = "Time Off Type";
export const SHIFT = "Shift";
export const ACTIONS = "Actions";

export const DESKTOP_MIN_WIDTH_PIXELS = 1024;
export const APPBAR_HEIGHT_PIXELS = 64;

// TODO: Flip to use common config station list
export function VALID_SWA_STATIONS() {
  const activeStationList = process.env.REACT_APP_ACTIVE_STATIONS;
  return activeStationList.split(",");
}

export const DEFAULT_FILTER_STATUS = "visibleStatus";
export const DEFAULT_FILTER_SHIFT = "shift";

export const NO_ACCESS = "NO_ACCESS";
export const NO_ACCESS_UNION_REP = "Union Salary FT";
export const EMPLOYEE_ACCESS = "Employee";
export const ADMIN_ACCESS = "Station Admin";
export const MULTI_STATION_ADMIN_ACCESS = "Multi-Station Admin";
export const ALL_ACCESS_LEVELS = [EMPLOYEE_ACCESS, ADMIN_ACCESS, MULTI_STATION_ADMIN_ACCESS];

export const BID_SERVICE_API_ADD_BID_EVENT = "addBidEvent";
export const BID_SERVICE_API_DELETE_PERM_BID_EVENT = "deletePermanentBidEvent";
export const BID_SERVICE_API_ADD_EMP_BID_CHOICE_EVENT = "addEmpBidChoiceEvent";
export const BID_SERVICE_API_GET_LATEST_BID_EVENTS_BY_STATION_AND_DATE = "getLatestBidEventsByStationAndDate";
export const BID_SERVICE_API_GET_LATEST_BID_EVENT_BY_REFERENCE_NUMBER = "getLatestBidEventByReferenceNumber";
export const BID_SERVICE_API_GET_BID_EVENTS_BY_REFERENCE_NUMBER = "getBidEventsByReferenceNumber";
export const BID_SERVICE_API_GET_BID_AUDIT_HISTORY_BY_REFERENCE_NUMBER = "getBidAuditHistoryByReferenceNumber";
export const BID_SERVICE_API_GET_LATEST_BID_GROUP_EMP_EVENTS_BY_REFERENCE_NUMBER =
  "getLatestBidGroupEmpEventsByReferenceNumber";
export const BID_SERVICE_API_GET_LATEST_BID_ALLOTMENT_EVENTS_BY_REFERENCE_NUMBER =
  "getLatestBidAllotmentEventsByReferenceNumber";
export const BID_SERVICE_API_GET_LATEST_BID_LINE_EVENTS_BY_REFERENCE_NUMBER = "getLatestBidLineEventsByReferenceNumber";
export const BID_SERVICE_API_GET_LATEST_BID_CHOICE_EVENTS_BY_EID_AND_DATE = "getLatestBidChoiceEventsByEidAndDate";
export const BID_SERVICE_API_GET_LATEST_BID_CHOICE_EVENT_BY_REFERENCE_NUMBER_AND_EID =
  "getLatestBidChoiceEventByReferenceNumberAndEid";
export const BID_SERVICE_API_GET_LATEST_BID_CHOICE_EVENTS_BY_REFERENCE_NUMBER =
  "getLatestBidChoiceEventsByReferenceNumber";
export const BID_SERVICE_API_GET_LATEST_AWARD_LOGS_BY_REFERENCE_NUMBER = "getLatestBidAwardLogsByReferenceNumber";
export const BID_SERVICE_API_CALCULATE_FREEDAY_ALLOTMENTS = "calculateFreedayAllotments";
export const BID_SERVICE_API_CALCULATE_IAM_FTO_ALLOTMENTS = "calculateIAMFTOAllotments";

export const PING_SERVICE_API_TOKEN = "token";
export const EMPLOYEE_SERVICE_API_GET_EMPLOYEE = "getEmployee";
export const EMPLOYEE_SERVICE_API_UPDATE_EMPLOYEE = "addEmployeeEvent";
export const EMPLOYEE_SERVICE_API_GET_EMPLOYEES_BY_STATION_WORKGROUP_WITH_DECLARATIONS =
  "getEmployeesByStationWorkgroupWithDeclarations";
export const EMPLOYEE_SERVICE_API_GET_EMPLOYEE_DECLARATION_EVENT_BY_EID_AND_DECLARATION_YEAR =
  "getEmployeeDeclarationEventByEidAndDeclarationYear";
export const EMPLOYEE_SERVICE_API_UPDATE_EMPLOYEE_DECLARATION = "addEmpDeclarationEvent";

export const GET_LATEST_DECLARATION_BALANCE_IMPORT_STATUS = "getLatestDeclarationBalanceImportStatus";
export const GET_ALLOTMENT_VALUE_BY_STATION_WORKGROUP_AND_YEAR = "getAllotmentValueByStationWorkgroupAndYear";

export const TRADE_SERVICE_API_ADD_TRADE_FORM_EVENT = "addTradeFormEvent";
export const TRADE_SERVICE_API_GET_LATEST_TRADE_EVENT_BY_REFERENCE_NUMBER = "getLatestTradeEventByReferenceNumber";
export const TRADE_SERVICE_API_GET_LATEST_TRADE_EVENT_BY_TRADE_FORM_ID = "getLatestTradeEventByTradeFormId";
export const TRADE_SERVICE_API_GET_LATEST_TRADE_EVENTS_BY_EMPLOYEE_AND_DATE = "getLatestTradeEventsByEmployeeAndDate";
export const TRADE_SERVICE_API_GET_LATEST_TRADE_EVENTS_BY_STATION_AND_DATE = "getLatestTradeEventsByStationAndDate";
export const TRADE_SERVICE_API_GET_TRADE_EVENTS_BY_TRADE_FORM_ID = "getTradeEventsByTradeFormId";
export const TRADE_SERVICE_API_ELIGIBILITY = "eligibility";

// TOR API calls currently live in a module named stars-trade-service-module unfortunately
export const TOR_SERVICE_API_GET_TIME_OFF_REQUEST_TYPES = "getTimeOffTypes";
export const TOR_SERVICE_API_ADD_TIME_OFF_REQUEST_EVENT = "addTimeOffRequestEvent";
export const TOR_SERVICE_API_GET_TIME_OFF_REQUEST_SNAPSHOTS_BY_EMPLOYEE_AND_DATE =
  "getTimeOffRequestSnapshotsByEmployeeAndDate";
export const TOR_SERVICE_API_GET_TIME_OFF_REQUEST_SNAPSHOTS_BY_STATION_AND_DATE =
  "getTimeOffRequestSnapshotsByStationAndDate";
export const TOR_SERVICE_API_GET_TIME_OFF_EVENTS_BY_TOR_ID = "getTimeOffRequestEventsByTorId";
export const TOR_SERVICE_API_GET_TIME_OFF_REQUEST_SNAPSHOT_BY_REFERENCE_NUMBER =
  "getTimeOffRequestSnapshotByReferenceNumber";
export const TOR_SERVICE_API_GET_LATEST_TIME_OFF_REQUEST_EVENT_BY_TOR_ID = "getLatestTimeOffRequestEventByTorId";
export const TOR_SERVICE_API_GET_TIME_OFF_REQUEST_SNAPSHOT_BY_TOR_ID = "getTimeOffRequestSnapshotByTorId";
export const TOR_SERVICE_API_GET_WOP_LIST = "getWOPList";
export const TOR_SERVICE_API_ADD_WOP_FREEZE_REQUEST = "addWopFreezeEvent";
export const TOR_SERVICE_API_GET_LATEST_WOP_FREEZE_EVENT = "getLatestWopFreezeEvent";
export const TOR_SERVICE_API_GET_WOP_FREEZE_EVENTS = "getWopFreezeEvents";
export const TOR_SERVICE_API_GET_WOP_FREEZE_AUDIT_EVENT = "getWopFreezeAuditEvent";
export const TOR_SERVICE_API_TOR_EVENT_ELIGIBILITY = "torEventEligibility";
export const TRADE_SERVICE_API_TRADE_EVENT_ELIGIBILITY = "tradeEventEligibility";

export const REPORT_API_GENERATE_TRADE_DETAIL_REPORT = "generateTradeDetailReport";
export const REPORT_API_GENERATE_TRADE_DAILY_REPORT = "generateDailyTradeReport";
export const REPORT_API_GENERATE_TOR_REPORT = "generateDailyTORReport";
export const REPORT_API_GENERATE_TOR_DETAIL_REPORT = "generateTORDetailReport";
export const REPORT_API_GENERATE_TAED_CONFLICT_REPORT = "generateConflictReport";
export const REPORT_API_GENERATE_PERMANENT_BID_REPORT = "generatePermanentBidReport";

export const SYSTEM_API_ERROR_LOG = "error";
export const SYSTEM_API_S3_PRESIGNED_URL_RETRIEVER = "s3/presignedUrl";
export const SYSTEM_API_COMMON_CONFIG = "common_config";
export const CFG_BID = Object.freeze({
  POSITIONS_MAP_NAME: "PERM_BID_POS",
  BID_TYPE: "BID_TYPE",
  ALL: "ALL",
});
export const CFG_EMP = Object.freeze({
  NAME: "CFG_EMP",
  ALL: "ALL",
  GO: "GO",
  TO: "TO",
  JOB_CODE: "JOB_CODE",
  WORKGROUP: "WORKGROUP",
  LIST: "LIST",
});
export const CFG_FA_GO = Object.freeze({
  NAME: "CFG_FA_GO",
  ALL: "ALL",
  FEATURE: "FEATURE",
  ACCESS_LINKS: "ACCESSLINKS",
  IS_CHILD_ITEM: "TRUE",
  IS_NOT_CHILD_ITEM: "FALSE",
  EMPLOYEE: "EMPLOYEE",
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
});

export const ALL_STATIONS = "allStations";
export const ALL_JOB_CODES = "allJobCodes";

export const CLEAR_ALL_NOTIFICATIONS = "CLEAR_ALL";
export const NOTIFICATION_API_GET_NOTIFICATIONS_BY_EMP = "getNotificationsByEmployee";
export const USER_ACCESS_API_GET_LATEST_USER_ACCESS_OVERRIDE_EVENT_BY_EMPLOYEE =
  "getLatestUserAccessOverrideEventByEmployee";
export const USER_ACCESS_API_GET_USER_ACCESS_OVERRIDE_EVENTS_BY_STATION = "getUserAccessOverrideEventsByStation";
export const USER_ACCESS_API_GET_SUPERUSER_ACCESS_BY_EMPLOYEE = "getSuperuserAccessByEmployee";
export const USER_ACCESS_API_ADD_USER_ACCESS_OVERRIDE_EVENT = "addUserAccessOverrideEvent";
export const USER_ACCESS_API_GET_ACCESS_BASED_ON_TOKEN = "GetAccessBasedOnToken";
export const USER_ACCESS_API_IS_USER_AUTHORIZED = "isUserAuthorized";
export const USER_ACCESS_API_GET_FEATURE_ACCESS = "getFeatureAccess";
export const TECH_USER_API_GET_PROXY_USER_SESSION = "getProxyUserSession";

export const SENIORITY_API_GENERATE_SENIORITY_LIST = "generateSeniorityList";
export const EMPLOYEE_API_GET_LAST_PUB_SL_EVENT = "getLastPublishedSLEvent";
export const EMPLOYEE_API_GET_LAST_PUB_SL_EVENT_BY_DECLARATION = "getLastPublishedSLEventByDeclaration";

export const TAED_SERVICE_API_ADD_TEMP_ASSIGNMENT_EVENT = "addTempAssignmentEvent";
export const TAED_SERVICE_API_GET_LATEST_EVENTS_BY_EID = "getLatestTAEDEventsByEid";
export const TAED_SERVICE_API_GET_TAED_SNAPSHOTS_BY_STATION_AND_DATE = "getTAEDSnapshotsByStationAndDate";
export const TAED_SERVICE_API_GET_TAED_SNAPSHOT_BY_REFERENCE_NUMBER = "getTAEDSnapshotByReferenceNumber";
export const TAED_SERVICE_API_GET_LATEST_EVENTS_BY_REFERENCE_NUMBER = "getTAEDEventsByReferenceNumber";
export const TAED_SERVICE_API_HAS_OVERLAPPING_TEMP_ASSIGNMENTS = "hasOverlappingTempAssignments";
export const TAED_SERVICE_API_GET_LATEST_EVENT_BY_REFERENCE_NUMBER = "getLatestTAEDEventByReferenceNumber";

export const BID_SERVICE_API_GET_PERMANENT_BID_PDF = "generatePermanentBidPDFReport";
export const BID_SERVICE_API_GET_LATEST_PERMANENT_BID_BY_EID = "getLatestPermanentBidEventByEid";
export const BID_SERVICE_API_GET_LATEST_PERMANENT_BID_BY_EID_AND_DATE = "getLatestPermanentBidEventByEidAndDate";

export const BID_AWARD_SERVICE_API_RUN_SHIFT_BID_AWARD = "runShiftBidAward";

export const BID_AWARD_SERVICE_API_RUN_FREEDAY_BID_AWARD = "runFreedayBidAward";

export const BID_AWARD_SERVICE_API_RUN_IAM_FTO_BID_AWARD = "runIAMFTOBidAward";

export const BID_AWARD_SERVICE_API_RUN_TWU_DAT_FTO_BID_AWARD = "runTWUDATFTOBidAward";

export const BID_AWARD_SERVICE_API_RUN_NC_PTO_FTO_BID_AWARD = "runNCPTOFTOBidAward";

export const BID_AWARD_SERVICE_API_RUN_NC_PTO_GOC_HOL_BID_AWARD = "runNCPTOGOCHOLBidAward";

export const ERROR_MAX_PAYLOAD_LIMIT_MSG = "MaxLambdaPayloadExceeded";

export const TWENTY_FOUR_HOURS_IN_MINUTES = 1440;

export const FOUR_HOURS_IN_MINUTES = 240;

export const FORTY_HOURS_IN_MINUTES = 2400;

export const TWU_CONTRACT = "TWU";

export const MAX_TWU_SHIFT_LENGTH_MINUTES = 510;

export const NON_CONTRACT = "Non-Contract";

export const MAX_NON_CONTRACT_SHIFT_LENGTH_MINUTES = 510;

export const MIN_NON_CONTRACT_SHIFT_LENGTH_MINUTES = 30;

export const IAM_CONTRACT = "IAM";

export const MAX_IAM_SHIFT_LENGTH_MINUTES = 630;

export const MIN_IAM_SHIFT_LENGTH_MINUTES = 30;

export const FREEFORM_REASON_CHAR_LIMIT = 50;

export const FREEFORM_REASON_CHAR_LIMIT_FOR_TEMP_ASSGNMENT = 100;

export const FREEFORM_REASON_CHAR_LIMIT_FOR_BID = 100;

export const WS_CLIENT_NORMAL_CLOSURE_CODE = 1000;

export const DAILY_TRADE_REPORT = "Daily Trade Report";
export const TRADE_DETAIL_REPORT = "Trade Detail Report";
export const DAILY_TIME_OFF_REQUEST_REPORT = "Daily Time Off Request Report";
export const TIME_OFF_REQUEST_DETAIL_REPORT = "Time Off Request Detail Report";
export const SCHEDULE_CONFLICT_REPORT = "Schedule Conflict Report";
export const PERMANENT_BID_REPORT = "Permanent Bid Report";

export const DST_WARNING =
  "Your selected shift starts/ends on Daylight Saving Time day. STARS may automatically adjust the shift to reflect the time change upon submission.";

export const TRADE_PAGE_TYPE = "TRADE";
export const BID_PAGE_TYPE = "BID";
export const CREATE_BID_PAGE_TYPE = "CREATE_BID";

export const BID_ADMIN_PAGE_TYPE = "BID_ADMIN";
export const BID_GROUP_PAGE_TYPE = "BID_GROUP";
export const BID_LINES_PAGE_TYPE = "BID_LINES";
export const BID_CHOICES_PAGE_TYPE = "BID_CHOICES";
export const BID_AWARD_NO_BID_PAGE_TYPE = "BID_AWARD_NO_BID";

// TempAssignment Constants
export const TEMPORARY_ASSIGNMENT_PAGE_TYPE = "TEMPORARY ASSIGNMENT";

export const TAED_FILTER_DATE_TYPES = Object.freeze({
  ACTIVE_DATE: "Active Date",
  START_DATE: "Start Date",
  END_DATE: "End Date",
  LAST_UPDATED_DATE: "Last Updated",
});

export const INCOMING_FILTER = "Incoming";
export const OUTGOING_FILTER = "Outgoing";

export const STATUS_ACTIVE = "Active";
export const STATUS_CANCELED = "Canceled";
export const STATUS_COMPLETED = "Completed";
export const STATUS_FUTURE = "Future";
export const EMPLOYEE_TEMP_LABEL = "Temp";
export const ALL_TAED_DATE_TYPE_FILTERS = Object.values(TAED_FILTER_DATE_TYPES);
export const ALL_TAED_INCOMING_OUTGOING_FILTERS = [INCOMING_FILTER, OUTGOING_FILTER];
export const ALL_TAED_STATUS_FILTERS = [STATUS_ACTIVE, STATUS_CANCELED, STATUS_COMPLETED, STATUS_FUTURE];

export const ALL_WORKGROUP_DEFAULT_FILTERS = [
  WORKGROUP_CSA,
  WORKGROUP_CARGO_AGENT,
  WORKGROUP_OPS_AGENT,
  WORKGROUP_PROVO_AGENT,
  WORKGROUP_RAMP_AGENT,
  WORKGROUP_ATW_SUP,
  WORKGROUP_BTW_SUP,
  WORKGROUP_CARGO_SUP,
  WORKGROUP_DUTY_SUP,
  WORKGROUP_PROVO_SUP,
  WORKGROUP_SSO_TEAM_LEAD,
  WORKGROUP_SSO_SPECIALIST,
  WORKGROUP_STA_ADMIN,
  WORKGROUP_MANAGER,
];

// TOR Constants
export const TIME_OFF_PAGE_TYPE = "TOR";

export const MIN_TOR_SHIFT_LENGTH_1_HOUR = 60;
export const MIN_TOR_SHIFT_LENGTH_4_HOURS = 240;
export const HAT_HOURS_LENGTH_MINUTES_MAXIMUM = 420;
export const HAT_HOURS_LENGTH_MINUTES_MINIMUM = 60;
export const HAT_INCREMENT_LENGTH_MINUTES = 60;
export const _4HOUR_VAC_LENGTH_MINUTES = 240;

export const DAT_TIME_OFF_TYPE = "DAT";
export const FTO_TIME_OFF_TYPE = "FTO";
export const FTO_GOC_HOL_TIME_OFF_TYPE = "FTO/GOC-HOL";
export const EAD_TIME_OFF_TYPE = "EAD";
export const EDU_TIME_OFF_TYPE = "EDU";
export const _4HOUR_VAC_TIME_OFF_TYPE = "4-Hour VAC";
export const HAT_TIME_OFF_TYPE = "HAT";
export const PTO_TIME_OFF_TYPE = "PTO";
export const HOL_TIME_OFF_TYPE = "HOL";
export const SEAD_TIME_OFF_TYPE = "SEAD";
export const LWOP_ALL_DAY_TIME_OFF_TYPE = "LWOP-ALL DAY";
export const LWOP_DAY_OF_TIME_OFF_TYPE = "LWOP-DAY OF";
export const TOWOP_ALL_DAY_TIME_OFF_TYPE = "TOWOP-ALL DAY";
export const TOWOP_DAY_OF_TIME_OFF_TYPE = "TOWOP-DAY OF";

export const JUNE_MONTH_NUM = 6;
export const FEBRUARY_MONTH_NUM = 2;
export const DECEMBER_MONTH_NUM = 12;

export const ALL_TIME_OFF_TYPES = [
  DAT_TIME_OFF_TYPE,
  FTO_TIME_OFF_TYPE,
  FTO_GOC_HOL_TIME_OFF_TYPE,
  EAD_TIME_OFF_TYPE,
  EDU_TIME_OFF_TYPE,
  _4HOUR_VAC_TIME_OFF_TYPE,
  HAT_TIME_OFF_TYPE,
  PTO_TIME_OFF_TYPE,
  HOL_TIME_OFF_TYPE,
  SEAD_TIME_OFF_TYPE,
  LWOP_ALL_DAY_TIME_OFF_TYPE,
  LWOP_DAY_OF_TIME_OFF_TYPE,
  TOWOP_ALL_DAY_TIME_OFF_TYPE,
  TOWOP_DAY_OF_TIME_OFF_TYPE,
];

export const ADMIN_ALL_TIME_OFF_TYPES = [
  DAT_TIME_OFF_TYPE,
  FTO_TIME_OFF_TYPE,
  FTO_GOC_HOL_TIME_OFF_TYPE,
  EAD_TIME_OFF_TYPE,
  EDU_TIME_OFF_TYPE,
  _4HOUR_VAC_TIME_OFF_TYPE,
  HAT_TIME_OFF_TYPE,
  PTO_TIME_OFF_TYPE,
  HOL_TIME_OFF_TYPE,
  SEAD_TIME_OFF_TYPE,
];

export const TIME_OFF_WOP_TYPES_BY_CONTRACT = {
  [IAM_CONTRACT]: [TOWOP_ALL_DAY_TIME_OFF_TYPE, TOWOP_DAY_OF_TIME_OFF_TYPE],
  [TWU_CONTRACT]: [LWOP_ALL_DAY_TIME_OFF_TYPE, LWOP_DAY_OF_TIME_OFF_TYPE],
  [NON_CONTRACT]: [LWOP_ALL_DAY_TIME_OFF_TYPE, LWOP_DAY_OF_TIME_OFF_TYPE],
};

export const TIME_OFF_ALL_WOP_TYPES = [
  TOWOP_ALL_DAY_TIME_OFF_TYPE,
  TOWOP_DAY_OF_TIME_OFF_TYPE,
  LWOP_ALL_DAY_TIME_OFF_TYPE,
  LWOP_DAY_OF_TIME_OFF_TYPE,
];

export const ALL_TIME_OFF_STATUSES = [
  STATUS_APPROVED,
  STATUS_CANCEL_SUBMITTED,
  STATUS_CANCELED_ADM,
  STATUS_CANCELED_EE,
  STATUS_EXPIRED_ADM,
  STATUS_REFUSED,
  STATUS_RETRACTED,
  STATUS_SUBMITTED,
];

export const WOP_AUDIT_CURRENT_LIST = "Current List";
export const WOP_AUDIT_DEFAULT_SELECTIONS = [WOP_AUDIT_CURRENT_LIST];

// Seniority List Constants
export const SENIORITY_LIST_PAGE_TYPE = "SENIORITY_LIST";

export const CLASSIFICATION_SENIORITY_LIST_TYPE = "Classification";
export const CONTRACT_VACATION_SENIORITY_LIST_TYPE = "Contract (Vacation)";
export const WN_SLI_SENIORITY_LIST_TYPE = "WN SLI";
export const FL_ATL_SENIORITY_LIST_TYPE = "FL ATL";
export const NON_CONTRACT_SENIORITY_LIST_TYPE = "Seniority";

export const CLASSIFICATION_SENIORITY_LIST_TYPE_BE = "IAM_CLASSIFICATION";
export const CONTRACT_VACATION_SENIORITY_LIST_TYPE_BE = "IAM_CONTRACT_VACATION";

export const ALL = "ALL";
export const FULL_TIME = "FT";
export const PART_TIME = "PT";

export const FTPT_FILTER = [ALL, FULL_TIME, PART_TIME];

export const IAM_SENIORITY_LIST_TYPES = [CLASSIFICATION_SENIORITY_LIST_TYPE, CONTRACT_VACATION_SENIORITY_LIST_TYPE];

export const TWU_SENIORITY_LIST_TYPES = [WN_SLI_SENIORITY_LIST_TYPE];

export const TWU_SENIORITY_LIST_TYPES_ATL = [FL_ATL_SENIORITY_LIST_TYPE];

export const NON_CONTRACT_SENIORITY_LIST_TYPES = [NON_CONTRACT_SENIORITY_LIST_TYPE];

export const CONTRACT_SENIORITY_LIST_TYPE_MAPPER = (userContract, station) => {
  if (userContract === IAM_CONTRACT) {
    return IAM_SENIORITY_LIST_TYPES;
  } else if (userContract === TWU_CONTRACT) {
    if (station === "ATL") {
      return TWU_SENIORITY_LIST_TYPES_ATL;
    }
    return TWU_SENIORITY_LIST_TYPES;
  } else if (userContract === NON_CONTRACT) {
    return NON_CONTRACT_SENIORITY_LIST_TYPES;
  } else {
    return [""];
  }
};

export const GET_IAM_SENIORITY_LIST_TYPE_FOR_API = {
  [CLASSIFICATION_SENIORITY_LIST_TYPE]: "IAM_CLASSIFICATION",
  [CONTRACT_VACATION_SENIORITY_LIST_TYPE]: "IAM_CONTRACT_VACATION",
};

export const GET_IAM_SENIORITY_LIST_TYPE_FOR_CLIENT = {
  [CLASSIFICATION_SENIORITY_LIST_TYPE_BE]: CLASSIFICATION_SENIORITY_LIST_TYPE,
  [CONTRACT_VACATION_SENIORITY_LIST_TYPE_BE]: CONTRACT_VACATION_SENIORITY_LIST_TYPE,
};

export const SENIORITY_MISSING_DATA = "MISSING_DATA";
export const SENIORITY_CRITICAL_MISSING_DATA = "CRITICAL_MISSING_DATA";
export const ALL_ISSUES = "ALL_ISSUES";
export const CRITICAL_ISSUES = "CRITICAL_ISSUES";
export const NON_CRITICAL_ISSUES = "NON_CRITICAL_ISSUES";

// Bid Constants
export const MANAGE_SHIFT_BID_TABS = Object.freeze({
  SET_UP_THE_SHIFT_BID: "SET UP THE SHIFT BID",
  MANAGE_BID_LINES: "MANAGE BID LINES",
  MANAGE_BID_GROUP: "MANAGE BID GROUP",
  AWARD: "AWARD",
});

export const MANAGE_TIMEOFF_BID_TABS = Object.freeze({
  SET_UP_THE_TIMEOFF_BID: "SET UP THE BID",
  MANAGE_BID_GROUP: "MANAGE BID GROUP",
  MANAGE_ALLOTMENTS: "MANAGE ALLOTMENTS",
  AWARD: "AWARD",
});

export const SENIORITY_LIST_TABS = Object.freeze({
  IN_PROGRESS: "IN PROGRESS",
  LAST_PUBLISHED: "LAST PUBLISHED",
});

export const GET_BID_SENIORITY_LIST_TYPE = (unionContract, station, bidType) => {
  if (unionContract === IAM_CONTRACT) {
    if (bidType === BID_TYPE.IAM_DAT) {
      return GET_IAM_SENIORITY_LIST_TYPE_FOR_CLIENT[CONTRACT_VACATION_SENIORITY_LIST_TYPE_BE];
    } else {
      return GET_IAM_SENIORITY_LIST_TYPE_FOR_CLIENT[CLASSIFICATION_SENIORITY_LIST_TYPE_BE];
    }
  } else if (unionContract === TWU_CONTRACT) {
    return station === "ATL" ? FL_ATL_SENIORITY_LIST_TYPE : WN_SLI_SENIORITY_LIST_TYPE;
  } else if (unionContract === NON_CONTRACT) {
    return NON_CONTRACT_SENIORITY_LIST_TYPE;
  } else {
    return "";
  }
};

export const FEATURES = Object.freeze({
  HOME: "home",
  NEW_HOME_DASHBOARD: "newHomeDashboard",
  ADMIN_TIME_OFF: "timeOffAdministration",
  CREATE_TIME_OFF: "createTimeOff",
  EMPLOYEE_TIME_OFF: "employeeTimeOff",
  REQUEST_TIME_OFF: "requestTimeOff",
  ADMIN_TIME_OFF_WOP: "lwopTowopAdmin",
  EMPLOYEE_TIME_OFF_WOP: "lwopTowopEmployee",
  ADMIN_TRADE: "tradeAdministration",
  CREATE_TRADE: "createTrade",
  EMPLOYEE_TRADE: "employeeTrades",
  REQUEST_TRADE: "requestTrade",
  GENERATE_REPORT: "generateReport",
  EMPLOYEE_DATA_MANAGEMENT: "employeeDataManagement",
  MY_PERMANENT_BID: "myPermanentBid",
  MANAGE_PERMANENT_BID: "managePermanentBid",
  BID: "bid",
  SENIORITY_LIST: "seniorityListAdmin",
  ACCESS_EXCEPTIONS: "accessExceptions",
  TECH_USER: "techUser",
  ADMIN_TEMPORARY_ASSIGNMENT: "tempAssignmentAdministration",
  CREATE_TEMPORARY_ASSIGNMENT: "createTemporaryAssignment",
  BID_ADMINISTRATION: "bidAdministration",
  MANAGE_BID: "manageBid",
  MY_BIDS: "myBids",
  MY_SENIORITY_LIST: "mySeniorityList",
  BID_CHOICES: "bidChoices",
  SCHEDULE_MANAGEMENT: "scheduleManagement",
  VOLUNTARY_OT_SIGNUP_LIST: "votSignUpList",
  DECLARATIONS: "declarations",
  MY_DECLARATIONS: "myDeclarations",
  DECLARATION_ADMINISTRATION: "declarationAdministration",
});

export const TECH_OPS_FEATURES = Object.freeze({
  HOME: "home",
  FEATURE_1: "feature1",
});

export const SPECIAL_USER_DASHBOARD_TITLE = "Support Dashboard";
export const SYSTEM_HEALTH_SUBTITLE = "System Health";
export const US_EAST_HEADER_LABEL = "us-east-1 (N. Virginia)";
export const US_WEST_HEADER_LABEL = "us-west-2 (Oregon)";
export const LAMBDA_SERVICE_VERSIONS_TITLE = "Lambda Service Versions";
export const EMPLOYEE_DATA_LOOKUP_TITLE = "Employee Data Lookup";

export const SPECIAL_ACCESS_FEATURES = Object.freeze({
  PROXY_LOGIN: "proxyLogin",
  FEATURE_ACCESS: "featureAccess",
  SERVICE_VERSION: "serviceVersion",
  GENERATE_REPORTS: "generateReports",
  EMPLOYEE_DATA_LOOKUP: "employeeDataLookup",
});

export const AWS_EAST_HEALTHCHECK_API_LIST = Object.freeze({
  ddb: process.env.REACT_APP_DYNAMODB_HEATH_CHECK_EAST,
  s3: process.env.REACT_APP_S3_HEATH_CHECK_EAST,
  lambda: process.env.REACT_APP_LAMBDA_HEATH_CHECK_EAST,
  sns: process.env.REACT_APP_SNS_HEATH_CHECK_EAST,
  ses: process.env.REACT_APP_SES_HEATH_CHECK_EAST,
});

export const AWS_WEST_HEALTHCHECK_API_LIST = Object.freeze({
  ddb: process.env.REACT_APP_DYNAMODB_HEATH_CHECK_WEST,
  s3: process.env.REACT_APP_S3_HEATH_CHECK_WEST,
  lambda: process.env.REACT_APP_LAMBDA_HEATH_CHECK_WEST,
  sns: process.env.REACT_APP_SNS_HEATH_CHECK_WEST,
  ses: process.env.REACT_APP_SES_HEATH_CHECK_WEST,
});

export const AWS_REGIONS = Object.freeze({
  EAST: "us-east-1",
  WEST: "us-west-2",
});

export const WEBSOCKET_CLOSE_REASON_LOGGING_OUT = "Logging out";

export const WEBSOCKET_CLOSE_REASON_CHANGING_STATIONS = "Changing stations";

export const WEBSOCKET_MSG_TYPE = Object.freeze({
  TRADE_EVENT: "TRADE_EVENT",
  TOR_EVENT: "TOR_EVENT",
  TAED_EVENT: "TAED_EVENT",
  BID_EVENT: "BID_EVENT",
  NOTIFICATION: "NOTIFICATION",
  BID_CHOICE_EVENT: "BID_CHOICE_EVENT",
  SCHEDULE_EVENT: "SCHEDULE_EVENT",
  FREEZE_EVENT: "FREEZE_EVENT",
});

export const FEATURE_ACCESS_TYPE = Object.freeze({
  GO: "GO_FA",
  TO: "TO_FA",
  SPECIAL: "SPECIAL_FA",
});

export const CANCEL_WARNING_MESSAGE_ACTION_TYPE = Object.freeze({
  DATA: "data",
  EDITS: "edits",
  SELECTIONS: "selections",
});

export const TAED_EVENT_TYPE = Object.freeze({
  CREATE: "CREATE",
  EDIT: "EDIT",
  DELETE: "DELETE",
});

export const ALL_TAED_EVENT_TYPES = ["CREATE", "EDIT", "DELETE"];

export const FAC_EVENT_TYPE = Object.freeze({
  CREATE: "CREATE",
  UPDATE: "UPDATE",
});

export const FAC_CONFIG_TYPES = Object.freeze({
  FEATURE: "feature",
  CHILD_ITEM: "childItem",
  ACCESS_LINKS: "accessLinks",
});

export const FAC_FUNCTIONALITY = Object.freeze({
  CREATE_FTR: "CREATE_FTR",
  CREATE_CI: "CREATE_CI",
  EDIT_FTR_OR_CI: "EDIT_FTR_OR_CI",
  EDIT_ACS_LNKS: "EDIT_ACS_LNKS",
});

export const REQUIRED_FIELD = "* Required Field";
export const PATH_REQUIRES_SLASH_ERROR = "* Path must begin with '/'";

export const BREADCRUMBS_TITLE = Object.freeze({
  HOME: "Home",
  TIME_OFF_ADMINISTRATION: "Time Off Administration",
  CREATE_TIME_OFF: "Create Time Off",
  MY_TIME_OFF: "My Time Off",
  REQUEST_TIME_OFF: "Request Time Off",
  ADMIN_TIME_OFF_WOP: "LWOP/TOWOP Administration",
  EMPLOYEE_TIME_OFF_WOP: "LWOP/TOWOP List",
  TRADE_ADMINISTRATION: "Trade Administration",
  CREATE_TRADE: " Create Trade",
  MY_TRADES: " My Trades",
  REQUEST_TRADE: "Request Trade",
  GENERATE_REPORT: "Generate Report",
  EMPLOYEE_DATA_MANAGEMENT: "Employee Data Management",
  SENIORITY_LIST_ADMIN: "Seniority List Administration",
  MY_SENIORITY_LIST: "My Seniority List",
  ACCESS_EXCEPTIONS: "Access Exceptions",
  TEMPORARY_ASSIGNMENT_ADMINISTRATION: "Temp Assignment Administration",
  CREATE_TEMPORARY_ASSIGNMENT: "Create Temp Assignment",
  EDIT_TEMPORARY_ASSIGNMENT: "Edit Temp Assignment",
  BID_ADMINISTRATION: "Bid Administration",
  MANAGE_SHIFT_BID: "Manage Shift Bid",
  MANAGE_FREE_DAY_BID: "Manage Freeday Bid",
  MANAGE_PERMANENT_BID: "Manage Permanent Bid",
  MANAGE_IAM_FTO_BID: "Manage FTO Bid",
  MANAGE_IAM_DAT_BID: "Manage DAT Bid",
  MANAGE_TWU_DAT_FTO_BID: "Manage DAT/FTO Bid",
  MANAGE_NC_PTO_FTO_BID: "Manage PTO/FTO Bid",
  MANAGE_NC_PTO_GOC_HOL_BID: "Manage PTO/GOC-HOL Bid",
  MY_BIDS: "My Bids",
  SHIFT_BID_CHOICES: "Shift Bid Choices",
  MY_PERMANENT_BID: "My Permanent Bid",
  SCHEDULE_MANAGEMENT: "Base Schedule Management",
  DECLARATION_ADMINISTRATION: "Declaration Administration",
  MY_DECLARATIONS: "My Declarations",
  VOLUNTARY_OT_LIST: "Voluntary OT List",
});

export const ADMIN_PDF_HEADER = "Admin";
export const EMPLOYEE_PDF_HEADER = "Employee View";

export const GO_ADMIN_EMAIL_ADDRESS = "GOAdministration@wnco.com";

export const FIRST_CHOICE = "1st choice";
export const SECOND_CHOICE = "2nd choice";
export const THIRD_CHOICE = "3rd choice";
export const FOURTH_CHOICE = "4th choice";

export const EARLIEST_AM = "earliestAM";
export const LATEST_AM = "latestAM";
export const EARLIEST_PM = "earliestPM";
export const LATEST_PM = "latestPM";

export const PERMANENT_BID_HOLIDAY_CHOICES = [FIRST_CHOICE, SECOND_CHOICE, THIRD_CHOICE, FOURTH_CHOICE];

export const PERMANENT_BID_DAYSOFF = ["Sat/Sun", "Sun/Mon", "Mon/Tue", "Tue/Wed", "Wed/Thu", "Thu/Fri", "Fri/Sat"];

export const PERMANENT_BID_DAYSOFF_ON_WEEKENDS = ["Sat/Sun", "Sun/Mon", "Fri/Sat"];

export const IAM_PERMANENT_BID_PREFERENCES_FOR_HOLIDAY = ["Operational", "Bag Service", "Curbside"];

export const IAM_PERMANENT_BID_PREFERENCES = ["Operational", "Bag Service", "Curbside", "Relief"];

export const TWU_PERMANENT_BID_PREFERENCES_FOR_HOLIDAY = ["Standard"];

export const TWU_PERMANENT_BID_PREFERENCES = ["Standard", "Relief"];

export const PERMANENT_BID_START_TIME_VALUES = [
  "00:00-00:29",
  "00:30-00:59",
  "01:00-01:29",
  "01:30-01:59",
  "02:00-02:29",
  "02:30-02:59",
  "03:00-03:29",
  "03:30-03:59",
  "04:00-04:29",
  "04:30-04:59",
  "05:00-05:29",
  "05:30-05:59",
  "06:00-06:29",
  "06:30-06:59",
  "07:00-07:29",
  "07:30-07:59",
  "08:00-08:29",
  "08:30-08:59",
  "09:00-09:29",
  "09:30-09:59",
  "10:00-10:29",
  "10:30-10:59",
  "11:00-11:29",
  "11:30-11:59",
  "12:00-12:29",
  "12:30-12:59",
  "13:00-13:29",
  "13:30-13:59",
  "14:00-14:29",
  "14:30-14:59",
  "15:00-15:29",
  "15:30-15:59",
  "16:00-16:29",
  "16:30-16:59",
  "17:00-17:29",
  "17:30-17:59",
  "18:00-18:29",
  "18:30-18:59",
  "19:00-19:29",
  "19:30-19:59",
  "20:00-20:29",
  "20:30-20:59",
  "21:00-21:29",
  "21:30-21:59",
  "22:00-22:29",
  "22:30-22:59",
  "23:00-23:29",
  "23:30-23:59",
];

export const CHOICE_ORDER = { "1st choice": 1, "2nd choice": 2, "3rd choice": 3, "4th choice": 4 };

export const INDEX_TO_CHOICE_MAP = {
  0: FIRST_CHOICE,
  1: SECOND_CHOICE,
  2: THIRD_CHOICE,
  3: FOURTH_CHOICE,
};

export const DAYS_OFF = "Days Off";

export const PREFERENCE = "Preference";

export const CLIENT = "CLIENT";

export const RELIEF = "Relief";

export const PERMANENT_BID_CHAR_LIMIT = 100;

export const STATION = "Station";

export const EMPLOYEE_ID = "Employee ID";

export const SUBMIT = "Submit";

export const CANCEL = "Cancel";

export const DELETE = "Delete";

export const SELECT_HOURS_LIST = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
];

export const SELECT_MINUTES_LIST = ["00", "15", "30", "45"];

export const SELECT_FREEDAY_BID_EFFECTIVE_MONTH_LIST = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
];

export const SELECT_IAM_FTO_BID_EFFECTIVE_MONTH_LIST = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const SELECT_IAM_DAT_BID_EFFECTIVE_MONTH_LIST = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const SELECT_TWU_DAT_FTO_BID_EFFECTIVE_MONTH_LIST = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const SELECT_SCHEDULE_MANAGEMENT_MONTH_LIST = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const SELECT_FREEDAY_BID_TYPE_LIST = ["Standard", "Relief"];

export const API_TIMEOUT = 30000;
export const BID_API_TIMEOUT = 90000;
export const API_POLLING_INTERVAL = 2000;

export const CONTRACT_TO_SENIORITY_DATES_MAP = {
  [IAM_CONTRACT]: [
    {
      label: "Classification Date",
      key: "classificationDate",
      isRequired: true,
    },
    {
      label: "Contract Date",
      key: "contractDate",
      isRequired: true,
    },
    {
      label: "Hire Date",
      key: "hireDate",
      isRequired: true,
    },
    {
      label: "Birth Date",
      key: "birthDate",
      isRequired: true,
    },
  ],
  [TWU_CONTRACT]: [
    {
      label: "WN SLI Seniority Date",
      key: "wnSliSeniorityDate",
      isRequired: true,
    },
    {
      label: "FL ATL Seniority Date",
      key: "flAtlSeniorityDate",
      isRequired: false,
    },
    {
      label: "Dual Seniority Date",
      key: "dualSeniorityDate",
      isRequired: true,
    },
    {
      label: "Hire Date",
      key: "hireDate",
      isRequired: true,
    },
    {
      label: "Birth Date",
      key: "birthDate",
      isRequired: true,
    },
  ],
  [NON_CONTRACT]: [
    {
      label: "Seniority Date",
      key: "seniorityDate",
      isRequired: true,
    },
    {
      label: "Hire Date",
      key: "hireDate",
      isRequired: true,
    },
    {
      label: "Birth Date",
      key: "birthDate",
      isRequired: true,
    },
  ],
};

export const SHIFT_BID_PDF_EXPORT_TYPES = Object.freeze({
  BID_LINES: "Bid Lines",
  CHOICES: "Choices",
  RESULTS: "Results",
});

export const FREEDAY_BID_PDF_EXPORT_TYPES = Object.freeze({
  CHOICES: "Choices",
  RESULTS: "Results",
});

export const EDM_CHAR_LIMIT = 100;

export const BID_GROUP_ADD_EMPLOYEE_CHAR_LIMIT = 100;

export const ADMIN_BID_CHOICE_CHAR_LIMIT = 100;

export const EMP_SCOPE = Object.freeze({
  DECLARATIONS: "declarations",
  BASE_SCHEDULES: "base_schedules",
});

export const BID_AWARD_SERVICE_API_RUN_IAM_DAT_BID_AWARD = "runIAMDATBidAward";

export const FREEDAY = "Freeday";

export const FTO = "FTO";

export const DECLARATION_CONFIG = "DECLARATION";

export const EMP_DECLARATION_CREATED_BY_TYPES = Object.freeze({
  CLIENT_ADMIN: "CLIENT-ADMIN",
  CLIENT_EMP: "CLIENT-EMP",
});

// eslint-disable-next-line
export const SPECIAL_CHARS = ["/", "\\", "?", "%", "*", ":", "|", '"', "<", ">"];

export const SPECIAL_CHARS_WITH_SPACES = ["/", "\\", "?", "%", "*", ":", "|", '"', "<", ">", " "];

export const DECLARATION_PAGE_TYPE = "DECLARATION_ADMIN";

export const DECLARATION_IMPORT_STATUSES = Object.freeze({
  INPROGRESS: "Inprogress",
  SUCCESS: "Success",
  FAILED: "Failed",
});

export const SELECT_NON_CONTRACT_BID_EFFECTIVE_MONTH_LIST = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
